import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";

import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalBody,
  Input,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import Breadcrumbs from "components/Common/Breadcrumb";

import { getComments, addComments } from "store/news/actions";

import "assets/scss/table.scss";
import moment from "moment";

class Csrcomments extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      modal: false,
      modalTitle: "",
      modalText: "",
      modalImage: "",
      modalDate: "",
      authUserId: localStorage.getItem("authUser")
        ? parseInt(JSON.parse(localStorage.getItem("authUser")).user_id)
        : null,

      participantId: this.props.match.params.id, // keep participant id separately
      newCommentText: "",
      isAddingComment: false,

      // feedbackListColumns: [
      //   {
      //     text: "Id",
      //     dataField: "id",
      //     sort: true,
      //     formatter: (cellContent, row) => <>{row.id}</>,
      //   },
      //   {
      //     text: "Comments",
      //     dataField: "text",
      //     sort: true,
      //     formatter: (cellContent, row) => (
      //       <span
      //         onClick={e => {
      //           e.preventDefault();
      //           this.setState({
      //             modal: true,
      //             modalTitle: row.text,
      //             modalText: row.description,
      //             modalImage: row.picture
      //               ? process.env.REACT_APP_BACKENDURL + row.picture
      //               : "",
      //             modalDate: moment(row.date_of_addition).format(
      //               "DD MMM YYYY, h:mm A"
      //             ),
      //           });
      //         }}
      //       >
      //         {row.text}
      //       </span>
      //     ),
      //   },
      //   {
      //     text: "Date of Addition",
      //     dataField: "date_of_addition",
      //     sort: true,
      //     formatter: (cellContent, row) => (
      //       <span>
      //         {moment(row.date_of_addition).format("DD MMM YYYY, h:mm A")}
      //       </span>
      //     ),
      //   },
      // ],
    };
  }

  componentDidMount() {
    const { match, location } = this.props;
    console.log("🔹 Raw location:", location);
    console.log("🔹 URL params:", match.params);

    const { id, schemeId, roundId } = match.params;
    const { state } = location || {};

    if (state) {
      console.log("✅ Received from Link state:", state);
      this.setState(
        {
          participantId: id,
          scheme_id: schemeId !== "null" ? schemeId : null,
          round_id: roundId !== "null" ? roundId : null,
          scheme_name: state.scheme_name || "",
          round_name: state.round_name || "",
        },
        () => {
          // ✅ Fetch comments after state is updated
          console.log(
            "📥 Fetching comments for participant:",
            this.state.participantId
          );
          this.props.onGetComments(this.state.participantId);
        }
      );
    } else {
      // ✅ Fallback: still fetch using id from URL if state is missing
      console.log("⚠️ No link state found. Using ID from URL:", id);
      this.props.onGetComments(id);
    }
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  handleAddComment = () => {
    const { newCommentText, authUserId, participantId, scheme_id, round_id } =
      this.state;
    const { onAddComments } = this.props;

    if (!newCommentText.trim()) return;

    const commentData = {
      added_by: authUserId,
      participant: parseInt(participantId),
      text: newCommentText.trim(),
      scheme_id: scheme_id || null, // ✅ include scheme info
      round_id: round_id || null,
    };

    this.setState({ newCommentText: "" });

    return new Promise((resolve, reject) => {
      onAddComments(commentData, resolve, reject);
    })
      .then(() => {
        this.props.onGetComments(participantId);
      })
      .catch(error => {
        console.error("Failed to add comment:", error);
      });
  };

  render() {
    const { SearchBar } = Search;
    const { news } = this.props;

    const pageOptions = {
      sizePerPage: 10,
      totalSize: news.length,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Comments</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Updates" breadcrumbItem="Comments" />

            {/* Add Comment Input + Button */}
            <Row className="justify-content-center">
              <Col lg="8">
                <Card className="shadow-sm">
                  <CardBody
                    style={{
                      height: "500px",
                      overflowY: "auto",
                      background: "#f5f7fb",
                    }}
                  >
                    {news && news.length > 0 ? (
                      [...news] // make a shallow copy
                        .sort(
                          (a, b) =>
                            new Date(a.date_added) - new Date(b.date_added)
                        ) // ✅ oldest first
                        .map(comment => (
                          <div
                            key={comment.id}
                            className={`d-flex mb-3 ${
                              comment.added_by === this.state.authUserId
                                ? "justify-content-end"
                                : "justify-content-start"
                            }`}
                          >
                            <div
                              className={`p-3 rounded-3 shadow-sm ${
                                comment.added_by === this.state.authUserId
                                  ? "bg-info-subtle text-dark"
                                  : "bg-primary-subtle text-dark"
                              }`}
                              style={{ maxWidth: "70%" }}
                            >
                              <div className="fw-bold mb-1">
                                {comment.added_by === this.state.authUserId
                                  ? "You"
                                  : comment.added_by_name || "Participant"}
                              </div>
                              <div>{comment.text}</div>

                              {/* ✅ Show scheme/round info if available */}
                              {(comment.scheme_name || comment.round_name) && (
                                <div
                                  className="text-muted mt-1"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {comment.scheme_name && (
                                    <span>
                                      <strong>Scheme: </strong>
                                      {comment.scheme_name}
                                    </span>
                                  )}
                                  {comment.scheme_name &&
                                    comment.round_name && <span> | </span>}
                                  {comment.round_name && (
                                    <span>
                                      <strong>Round:</strong>{" "}
                                      {comment.round_name}
                                    </span>
                                  )}
                                </div>
                              )}

                              <small
                                className="text-muted d-block mt-1"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {moment(comment.date_added).format(
                                  "DD-MMM-YY, h:mm A"
                                )}
                              </small>
                            </div>
                          </div>
                        ))
                    ) : (
                      <p className="text-center text-muted">No comments yet.</p>
                    )}
                  </CardBody>

                  {/* Input Box like Chat */}
                  <div className="d-flex border-top p-3">
                    <Input
                      type="text"
                      placeholder="Type your comment..."
                      value={this.state.newCommentText}
                      onChange={e =>
                        this.setState({ newCommentText: e.target.value })
                      }
                      onKeyDown={e => {
                        if (
                          e.key === "Enter" &&
                          this.state.newCommentText.trim()
                        ) {
                          this.handleAddComment();
                        }
                      }}
                    />
                    <Button
                      color="primary"
                      className="ms-2"
                      disabled={!this.state.newCommentText.trim()}
                      onClick={this.handleAddComment}
                    >
                      Send
                    </Button>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Csrcomments.propTypes = {
  news: PropTypes.array,
  onAddComments: PropTypes.func.isRequired,
  onGetComments: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      schemeId: PropTypes.string, // ✅ add this
      roundId: PropTypes.string, // ✅ add this
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.object, // ✅ optional, fixes state validation warning
  }),
};

const mapStateToProps = ({ news }) => ({
  news: news.news,
});

const mapDispatchToProps = dispatch => ({
  onAddComments: (data, resolve, reject) =>
    dispatch({ type: "ADD_COMMENTS", payload: data, resolve, reject }),
  onGetComments: id => dispatch(getComments(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Csrcomments));
